import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { PERSON_INN_LENGTH } from '../../constants/requisitesLength';
import { checkExactLength, checkInnFormat, checkMatch, checkNotEmpty, validateBaseRequisites, } from '../../helpers/validators';
import { MatchLink } from '../MatchLink';
const validateInn = ({ value, required, requiredMessage }) => {
    const inn = (value || '').replace(/\D/g, '');
    if (required) {
        return (checkNotEmpty({ value, message: requiredMessage }) ||
            checkExactLength({ value: inn, length: PERSON_INN_LENGTH }) ||
            checkInnFormat({ value: inn }));
    }
    if (!value) {
        return null;
    }
    return checkExactLength({ value, length: PERSON_INN_LENGTH }) || checkInnFormat({ value });
};
const checkMatchInn = ({ value, matchValue, matchEmployeeLink, level, }) => {
    const message = (_jsxs(_Fragment, { children: ["\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A \u0441 \u0442\u0430\u043A\u0438\u043C \u0418\u041D\u041D \u0443\u0436\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u0435\u0442", matchEmployeeLink && '. ', matchEmployeeLink && _jsx(MatchLink, { matchEmployeeLink: matchEmployeeLink })] }));
    return checkMatch({ value, matchValue, matchFields: ['inn'], message, level });
};
export const validateInnWithMatch = ({ snils, inn, lastName, firstName, required, matchInnProps, }) => {
    return (validateInn({ value: inn, required }) ||
        validateBaseRequisites({ snils, inn, lastName, firstName }) ||
        checkMatchInn(matchInnProps));
};
